import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type HelpCenterLinkType = 'article' | 'collection' | 'q';

type UseHelpCenterLink = (id?: number | string, type?: HelpCenterLinkType) => string;

const useHelpCenterLink: UseHelpCenterLink = (id, type = 'article') => {
    const { i18n } = useTranslation();

    const pathType = useMemo(() => {
        switch (type) {
            case 'collection':
                return '/collections/';
            case 'article':
                return '/articles/';
            case 'q':
                return '?q=';
            default:
                return '/';
        }
    }, [type]);

    return import.meta.env.VITE_HELP_CENTER_URL + pathType + id;
};

export default useHelpCenterLink;
